import { render, staticRenderFns } from "./HeaderInformationNavigationBbw.vue?vue&type=template&id=425fcab4&scoped=true"
import script from "./HeaderInformationNavigationBbw.vue?vue&type=script&lang=ts"
export * from "./HeaderInformationNavigationBbw.vue?vue&type=script&lang=ts"
import style0 from "./HeaderInformationNavigationBbw.vue?vue&type=style&index=0&id=425fcab4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425fcab4",
  null
  
)

export default component.exports